export async function setupAppcues(accountId: string, appId: string) {
  // For mobile app implementation see `appcues.native.ts`
}

export async function appcuesDidHandleURL(url: string) {
  // For mobile app implementation see `appcues.native.ts`
  return false;
}

export function appcuesIdentify(userId: string, userProperties?: object) {
  // window.Appcues?.identify(userId, userProperties);
}

export function setAppcuesScreen(screen: string, properties?: object) {
  // return window.Appcues?.page();
}
